export default __webpack_public_path__ + "static/media/sample_transport.6a5c74cd.png";